import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormTrade from '../../forms/FormTrade.jsx';

const PageTrade = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    if (_id !== 'new') {
      req({ url: `/api/site/trades/${_id}` });
    }
  }, [_id]);

  const breadcrumb = _id === 'self' ? [] : [
    { to: '../', children: 'Trades' },
  ];

  return _id === 'new' ? (
    <>
      <Header breadcrumb={breadcrumb}>New Trade</Header>
      <FormTrade />
    </>
  ) : (
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header breadcrumb={breadcrumb}>Edit</Header>
          <FormTrade
            trade={doc}
          />
        </>
      )}
    </PageHttp>
  );
};

export default PageTrade;
